import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '../assets/css/globals.css'

// Find the root element
const rootElement = document.getElementById('root');

// Make sure rootElement exists
if (!rootElement) {
    throw new Error("Failed to find the root element");
}

// Create a root
const root = createRoot(rootElement);

// Render the App component
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);